import { dhFoodsAuth } from "./api"

const endpoint = "/access"

export const getAccess = async (accessId) => {
  const response = await dhFoodsAuth.get(`${endpoint}/${accessId}`)

  return response.data
}

export const getAccesses = async () => {
  const response = await dhFoodsAuth.get(`${endpoint}`)

  return response.data
}

export const createAccess = async (data) => {
  const response = await dhFoodsAuth.post(`${endpoint}`, data)

  return response.data
}

export const editAccess = async (accessId, data) => {
  const response = await dhFoodsAuth.patch(`${endpoint}/${accessId}`, data)

  return response.data
}

export const deleteAccess = async (accessId) => {
  const response = await dhFoodsAuth.delete(`${endpoint}/${accessId}`)

  return response.data
}